export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пішін өрістері №."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Міндетті идентификатор жоқ"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сіз жүйеге сәтті кірдіңіз, банкоматта операцияларды жалғастырыңыз"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Банкомат операцияларын жалғастыру"])}
}